<template>
  <div class="overview container">
    <!-- <h2>Overview</h2>
    <p>
      Welcome to the Admin Dashboard! Here's a quick summary of your system:
    </p> -->

    <!-- Key Metrics Cards -->
      <div class="row">

      <!-- Total Orders -->
      <div class="col-12 col-sm-6 col-lg-3 mb-4">
        <div class="stat-card">
          <i class="fa fa-box-open fa-2x text-primary"></i>
          <h3>Total Orders</h3>
          <p>{{total_orders}}</p>
        </div>
      </div>

      <!-- Total Revenue -->
      <div class="col-12 col-sm-6 col-lg-3 mb-4">
        <div class="stat-card">
          <i class="fa fa-dollar-sign fa-2x text-success"></i>
          <h3>Total Revenue</h3>
          <p>TZS {{total_sales}}</p>
        </div>
      </div>

      <!-- Active Users -->
      <div class="col-12 col-sm-6 col-lg-3 mb-4">
        <div class="stat-card">
          <i class="fa fa-users fa-2x text-info"></i>
          <h3>Active Users</h3>
          <p>{{active_users}}</p>
        </div>
      </div>

      <!-- Pending Orders -->
      <div class="col-12 col-sm-6 col-lg-3 mb-4">
        <div class="stat-card">
          <i class="fa fa-clock fa-2x text-warning"></i>
          <h3>Pending Orders</h3>
          <p>{{pending_orders}}</p>
        </div>
      </div>

      <!-- Completed Orders -->
      <div class="col-12 col-sm-6 col-lg-3 mb-4">
        <div class="stat-card">
          <i class="fa fa-check-circle fa-2x text-success"></i>
          <h3>Completed Orders</h3>
          <p>{{completed_orders}}</p>
        </div>
      </div>

      <!-- Failed Payments -->
      <div class="col-12 col-sm-6 col-lg-3 mb-4">
        <div class="stat-card">
          <i class="fa fa-times-circle fa-2x text-danger"></i>
          <h3>Failed Payments</h3>
          <p>{{failed_payments}}</p>
        </div>
      </div>

      <!-- Total Products -->
      <div class="col-12 col-sm-6 col-lg-3 mb-4">
        <div class="stat-card">
          <i class="fa fa-box fa-2x text-secondary"></i>
          <h3>Total Products</h3>
          <p>{{total_products}}</p>
        </div>
      </div>

      <!-- Low Stock Products -->
      <div class="col-12 col-sm-6 col-lg-3 mb-4">
        <div class="stat-card">
          <i class="fa fa-exclamation-triangle fa-2x text-danger"></i>
          <h3>Low Stock</h3>
          <p>{{low_stock_products}}</p>
        </div>
      </div>

    </div>

    <!-- Charts Section -->
    <div class="row mt-4">
      <!-- Yearly Sales Chart Card -->
      <div class="col-12 col-lg-8 mb-4">
        <div class="chart-card">
          <h3>Yearly Sales</h3>
          <!-- Line Chart Canvas with Fixed Height and Width -->
          <canvas ref="lineChart" style="height: 40px; width: 100%"></canvas>
        </div>
      </div>

      <!-- Today's Selling Categories Chart Card -->
      <div class="col-12 col-lg-4 mb-4">
        <div class="chart-card">
          <h3>Today's Selling Categories</h3>
          <!-- Pie Chart Canvas with Fixed Height and Width -->
          <canvas ref="pieChart" style="height: 40px; width: 100%"></canvas>
        </div>
      </div>
    </div>

    <!-- Recent Orders Table -->
<div class="table-card">
  <h3>Recent Orders</h3>

  <div class="table-responsive">
    <table class="table table-hover">
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Customer</th>
                <th>Phone</th>
                <th>Amount</th>
                <th>Payment</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="order in recent_orders" :key="order.id">
                <td>
                  <a href="#">{{ order.order_number }}</a>
                </td>
                <td>{{ order.user.first_name + ' ' +  order.user.last_name }}</td>
                <td>{{ order.user.phone }}</td>
                <td>TZS {{ order.total_amount }}</td>
                <td>{{ order.payment_status.name }}</td>
                <td>
                  <span class="badge bg-warning">
                    <i class="fa fa-clock"></i>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
  </div>
</template>

<script setup>
import { fetchDashboardData } from "@/API-requests/Requests";
import Chart from "chart.js/auto"; // Import Chart.js
import { ref, computed, onMounted, nextTick } from "vue";



const total_sales = ref(0.0);
const total_orders = ref(0);
const pending_orders = ref(0);
const completed_orders = ref(0);
const active_users = ref(0);
const failed_payments = ref(0);
const total_products = ref(0);
const low_stock_products = ref(0);
const recent_orders = ref([]);
const yearly_sales = ref([]);
const topCategories = ref([]);
const chartInstance = ref(null);

// Chart references
const lineChart = ref(null);
const pieChart = ref(null);


//here we ill create charts instances
const createyearlysaleschart = () => {
  if (chartInstance.value) {
    chartInstance.value.destroy();
  }

  chartInstance.value = new Chart(lineChart.value, {
    type: "line",
    data: {
      labels: [
        "Jan","Feb","Mar","Apr","May","Jun",
        "Jul","Aug","Sep","Oct","Nov","Dec"
      ],
      datasets: [
        {
          label: "Yearly Sales",
          data: yearly_sales.value,
          borderColor: "#42b983",
          backgroundColor: "rgba(66, 185, 131, 0.2)",
          fill: true,
        },
      ],
    },
    options: {
      responsive: false,
      maintainAspectRatio: false,
    },
  });
};

//todays top selling categories
const createPieChart = () => {
  new Chart(pieChart.value, {
    type: "pie",
    data: {
      labels: topCategories.value.labels,
      datasets: [
        {
          label: "Today's Selling Categories",
          data: topCategories.value.data,
          backgroundColor: [
            "#42b983",
            "#ff6384",
            "#36a2eb",
            "#ffcd56",
            "#4bc0c0",
            "#9966ff",
          ],
        },
      ],
    },
    options: {
      responsive: false,
      maintainAspectRatio: false,
    },
  });
};



// Initialize charts
onMounted(() => {

  fetchdata();

});


const fetchdata = async () => {
  try {
    // loading.value = true;
    // await nextTick();

    const response = await fetchDashboardData();

      total_sales.value =response.total_sales,
      total_orders.value = response.total_orders,
      pending_orders.value = response.pending_orders,
      completed_orders.value = response.completed_orders,
      active_users.value = response.active_users,
      failed_payments.value = response.failed_payments,
      total_products.value = response.total_products,
      low_stock_products.value = response.low_stock_products,
      recent_orders.value = response.recent_orders,
      yearly_sales.value = response.yearly_sales,
      topCategories.value = response.top_categories_today,

      createyearlysaleschart();
      createPieChart();

  } catch (error) {
    console.error("Error loading data:", error);
    // flashMessage.value.showFlashMessage("error", "Failed to load data");
  }
}
</script>
<style scoped>
/* Overview Container */
.overview {
  max-width: 100%;
  padding: 20px;
  box-sizing: border-box;
}

/* Stats Cards */
.stat-card {
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.stat-card h3 {
  margin-bottom: 10px;
  font-size: 1.2rem;
  color: #333;
}

.stat-card p {
  font-size: 1.5rem;
  font-weight: bold;
  color: #42b983;
}

/* Chart Cards */
.chart-card {
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  height: 100%; /* Ensures the chart card fills the parent container */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* Canvas inside the chart card */
canvas {
  flex: 1; /* Ensures canvas takes the available space */
  height: 400px !important; /* Fixed height for the chart */
  width: 100% !important; /* Makes the chart responsive and fits the container */
}

/* Table Cards */
.table-card {
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.table-card h3 {
  margin-bottom: 20px;
}

/* Badge Styling */
.badge {
  font-size: 0.6rem;
  padding: 3px 10px;
  border-radius: 5px;
  display: inline-block;
}

/* Responsive Adjustments */
@media (max-width: 767px) {
  .chart-card {
    padding: 15px;
  }

  .stat-card h3 {
    font-size: 1rem;
  }

  .stat-card p {
    font-size: 1.2rem;
  }

  /* Ensure table fits in smaller screens */
  .table-card {
    padding: 10px;
  }
}
</style>
